import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exp-save",
  "use": "icon-exp-save-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" fill=\"none\" id=\"icon-exp-save\">\n  <path d=\"M12 14.5 8 11.3l-4 3.2V4.17c0-.74.6-1.34 1.33-1.34h5.34c.73 0 1.33.6 1.33 1.34V14.5Z\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol